import type { MenuOptionType } from "@dexteel/mesf-core";
import type { MouseEvent, ReactNode } from "react";
import type {
  GanttBackgroundContext,
  ProcessLine,
} from "../../../../../controls/ganttAsset/types/public-types";
import type { StrandLoss } from "../../../../../controls/ganttAsset/types/strand-loss";
import type { Asset, Process } from "../../../models/ProcessGanttChart";

export const GANTT_PROCESS_MENU_ID = "ganttSection";
export const GANTT_DELAY_MENU_ID = "ganttSectionDelaysMenu";

export const showGanttDelayContextMenu = (
  event: MouseEvent<Element>,
  delay: ProcessLine,
  selectAssetId: (id: number) => void,
  selectDelayId: (id: number) => void,
  showMenu: (
    event: MouseEvent<Element>,
    data: ProcessLine,
    menuId: string,
  ) => void,
  hideMenu: () => void,
): void => {
  const assetId = Number(delay.id);
  const delayId = delay.DelayId;
  if (
    !Number.isInteger(assetId) ||
    assetId <= 0 ||
    typeof delayId !== "number" ||
    !Number.isInteger(delayId) ||
    delayId <= 0
  ) {
    hideMenu();
    return;
  }
  selectAssetId(assetId);
  selectDelayId(delayId);
  showMenu(event, delay, GANTT_DELAY_MENU_ID);
};

export const routeGanttDirectMenu = (
  event: MouseEvent<Element>,
  data: Process | ProcessLine,
  selectTime: (time: Date) => void,
  showProcessMenu: (
    event: MouseEvent<Element>,
    data: Process | ProcessLine,
    menuId: string,
  ) => void,
  showDelayMenu: (event: MouseEvent<Element>, delay: ProcessLine) => void,
): void => {
  if ("timestamp" in data && data.timestamp instanceof Date) {
    selectTime(data.timestamp);
  }
  if ("type" in data && data.type === "taskLine") {
    if (data.eventCode === "D") showDelayMenu(event, data);
    return;
  }
  showProcessMenu(event, data, GANTT_PROCESS_MENU_ID);
};

export const getNewProcessMenuOption = (
  assetId: string | number,
  createProcess: (assetId: number) => void,
  icon: ReactNode,
): MenuOptionType => ({
  name: "New Process",
  key: "toggle_status",
  onClick: () => createProcess(Number(assetId)),
  icon,
});

export const routeGanttBackgroundMenu = (
  event: MouseEvent<HTMLDivElement>,
  hit: GanttBackgroundContext,
  selectAsset: (asset: Asset) => void,
  selectTime: (time: Date) => void,
  showMenu: (
    event: MouseEvent<HTMLDivElement>,
    hit: GanttBackgroundContext,
    menuId: string,
  ) => void,
  hideMenu: () => void,
  showLossMenu: (event: MouseEvent<Element>, loss: StrandLoss) => void,
  showDelayMenu: (
    event: MouseEvent<Element>,
    delay: ProcessLine,
  ) => void = () => {},
): void => {
  if (hit.zone !== "process") {
    hideMenu();
    if (
      hit.zone === "delay" &&
      (hit.asset.name === "Caster" || hit.asset.name === "EAF") &&
      hit.nearestDelay
    ) {
      showDelayMenu(event, hit.nearestDelay);
    } else if (
      hit.zone === "strand" &&
      hit.asset.name === "Caster" &&
      hit.nearestLoss
    ) {
      showLossMenu(event, hit.nearestLoss);
    }
    return;
  }
  selectAsset({ id: hit.asset.id, AssetName: hit.asset.name });
  selectTime(hit.timestamp);
  showMenu(event, hit, GANTT_PROCESS_MENU_ID);
};
